<div class="c-loader__wrapper">
  <!-- <svg class="svg" viewBox="50 50 100 100">
    <circle class="loader" cx=100 cy=100 r=46 ></circle>
  </svg> -->



  <div class="c-loader__circle c-loader__circle--red"></div>
  <div class="c-loader__circle c-loader__circle--blue"></div>
  <div class="c-loader__circle c-loader__circle--green"></div>
  <div class="c-loader__circle c-loader__circle--yellow"></div>
</div>
